<template>
  <a-tooltip :title="$t('data.RoleData.950813-34')">
    <a href="https://resource.jetlinks.cn" target="_blank" style="color: #000">
      <AIcon type="icon-ziyuanku"/>
    </a>
  </a-tooltip>
</template>